import { IsString, MaxLength, IsNotEmpty, IsOptional, MinLength, IsArray } from 'class-validator';

export class PositionEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    contacts: Array<string>;

}
